export default __webpack_public_path__ + "static/media/sickle-cell.2c02c764.png";